/* possoftware/reducer */
import { createReducer } from "typesafe-actions";
import { PosSoftwareActionTypes, PosSoftwareState } from "./types";
import {
  fetchRequest,
  fetchSuccess,
  fetchError,
  saveRequest,
  saveSuccess,
  saveError,
  deleteRequest,
  deleteSuccess,
  deleteError
} from "./actions";

export const initialState: PosSoftwareState = {
  data: undefined,
  errors: undefined,
  loading: false
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof saveRequest>
  | ReturnType<typeof saveSuccess>
  | ReturnType<typeof saveError>
  | ReturnType<typeof deleteRequest>
  | ReturnType<typeof deleteSuccess>
  | ReturnType<typeof deleteError>;

export default createReducer<PosSoftwareState, ActionType>(initialState)
  .handleType(PosSoftwareActionTypes.FETCH, state => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(PosSoftwareActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined
    };
  })
  .handleType(PosSoftwareActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: undefined,
      errors: action.payload
    };
  })
  .handleType(PosSoftwareActionTypes.SAVE_REQUEST, state => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(PosSoftwareActionTypes.SAVE_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined
    };
  })
  .handleType(PosSoftwareActionTypes.SAVE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
      data: undefined
    };
  })
  .handleType(PosSoftwareActionTypes.DELETE_REQUEST, state => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(PosSoftwareActionTypes.DELETE_SUCCESS, state => {
    return {
      ...state,
      loading: false,
      errors: undefined
    };
  })
  .handleType(PosSoftwareActionTypes.DELETE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload
    };
  });
